var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert",attrs:{"role":"alert"}},[_c('icon',{attrs:{"icon":['fad', this.icon]}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }